import { useEffect, useEffectEvent, useRef, useState } from "react";
import type { AnyEquation } from "@src/features/equation-editor/equation";
import type { Translate } from "@src/i18n/translate";

const RESULT_ANNOUNCEMENT_DELAY_MS = 400;

export function useResultStatus(
  evaluationKind: AnyEquation["evaluation"]["kind"],
  resultRevision: string,
  t: Translate,
): string {
  const [announcement, setAnnouncement] = useState<{
    revision: string;
    message: string;
  } | null>(null);
  const announcedRevision = useRef(resultRevision);
  const getAnnouncement = useEffectEvent(() => t("transformedVectorsUpdated"));

  useEffect(() => {
    if (
      evaluationKind !== "current" ||
      resultRevision === announcedRevision.current
    )
      return;

    const timer = window.setTimeout(() => {
      announcedRevision.current = resultRevision;
      setAnnouncement({
        revision: resultRevision,
        message: getAnnouncement(),
      });
    }, RESULT_ANNOUNCEMENT_DELAY_MS);
    return () => {
      window.clearTimeout(timer);
    };
  }, [evaluationKind, resultRevision]);

  if (evaluationKind === "evaluating") return t("evaluatingExpressions");
  if (evaluationKind === "stale") return t("staleResults");
  return announcement?.revision === resultRevision ? announcement.message : "";
}
